// Césures conditionnelles (U+00AD) pour les grands titres : la police Syne en capitales
// est très large et certains mots dépassent la largeur d'un téléphone. Le trait d'union
// n'apparaît que si le mot doit réellement être coupé, au bon endroit.
const SHY = "\u00ad";
const BREAKS = [
  "confiden|tialité", "régle|mentaires", "informa|tions", "utili|sation", "chauffa|giste",
  "climati|cien", "charpen|tier", "métal|lique", "revête|ments", "entre|preneur",
  "prépa|ration", "assu|rance", "décen|nale", "obte|nir", "électri|cien", "spécia|liste",
  "isola|tion", "exté|rieur", "terras|sier", "prévo|yance", "obliga|toire", "garan|ties", "attes|tation", "ques|tion", "protec|tion", "cons|truire", "arti|sans",
];
const RULES = BREAKS.map((word) => {
  const [a, b] = word.split("|");
  return [new RegExp(`(${a})(${b})`, "gi"), `$1${SHY}$2`];
});

export const hy = (text) => RULES.reduce((out, [re, rep]) => out.replace(re, rep), text);
